import { connect } from 'react-redux'
import ServiceArchiveModal from '../../components/services/ServiceArchiveModal'
import { serviceArchive, actionCreators } from '../../state/actions/services'
import {
  getService,
  getServiceArchiveServiceId,
  getServiceProcessing,
  getServiceProcessingError
} from '../../state/reducers/services'
import { IStoreState } from '../../types'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  const serviceId = getServiceArchiveServiceId(state)
  return {
    service: serviceId ? getService(state, serviceId) : undefined,
    processing: getServiceProcessing(state),
    error: getServiceProcessingError(state)
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onCancelClick: () => {
      dispatch(actionCreators.serviceArchiveModalHide())
    },
    onArchiveClick: (serviceId: string) => {
      dispatch(serviceArchive(serviceId))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceArchiveModal)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceArchiveModal.ts